import { useCallback } from 'react'
import ErrorText from '../ErrorText'
import styles from './style.module.scss'

export default function MultiSelect({ options, values, onChange, error, errorMessage }) {
  const _onChange = useCallback(
    (flag, optionValue) => {
      let newValues = [...values]

      // if checked, remove the value
      if (flag) {
        newValues.push(optionValue)
      } else {
        newValues = newValues.filter(val => val !== optionValue)
      }

      onChange && onChange(newValues)
    },
    [onChange, values],
  )

  return (
    <div className={styles.form_multi_select_container}>
      {options.map((option, i) => {
        const isChecked = values.includes(option.value)

        return (
          <div
            key={i}
            className={styles.form_multi_select_checker_row}
            onClick={() => _onChange(!isChecked, option.value)}>
            <input
              type="checkbox"
              value={option.value}
              className={styles.form_multi_select_checker}
              checked={isChecked}
            />
            <span>{option.label}</span>
          </div>
        )
      })}

      {error && <ErrorText errorMessage={errorMessage} />}
    </div>
  )
}
